import * as React from 'react';
import { ListInstanceItem } from 'ec2launcher/queries';
import { Table, TableRow } from 'shared/components';
import Ec2InstanceListItem from './Ec2InstanceListItem';
import { TableCellItem } from 'shared/components/TableRow';

interface Props {
  refetch: () => Promise<any>;
  colWidths: string[];
  headers: TableCellItem[];
  instances: ListInstanceItem[];
}

class Ec2InstanceList extends React.Component<Props> {
  render() {
    const {
      instances = [],
      refetch,
      headers,
      colWidths = [],
    } = this.props;
    return (
      <>
        <Table headers={headers} colWidths={colWidths}>
          {instances.map((instance) => (
            <TableRow<ListInstanceItem>
              key={instance.launchId}
              item={instance}
              refetch={refetch}
              component={Ec2InstanceListItem}
            />
          ))}
        </Table>
      </>
    );
  }
}

export default Ec2InstanceList;
